<!--
  Одно вложение сообщения чата: миниатюра изображения или файловая ссылка.
-->
<template>
  <button
    type="button"
    class="chat-attachment-item"
    :class="{
      'chat-attachment-item_image': attachmentIsImage,
    }"
    @click.stop="$emit('preview', attachment)"
  >
    <img
      v-if="attachmentIsImage"
      :src="attachmentLink"
      :alt="attachment.name || 'Вложение'"
      class="chat-attachment-item__image"
    />
    <span v-else class="chat-attachment-item__file">
      {{ attachment.name || 'Вложение' }}
    </span>
  </button>
</template>

<script>
import { attachmentUrl, isImage, resolveUrl } from "@/utils/fileUtils";

export default {
  name: "ChatAttachmentItem",

  props: {
    attachment: {
      type: Object,
      required: true,
    },
  },

  emits: ["preview"],

  computed: {
    attachmentIsImage() {
      return isImage(this.attachment);
    },

    attachmentLink() {
      return resolveUrl(attachmentUrl(this.attachment));
    },
  },
};
</script>

<style scoped>
.chat-attachment-item {
  padding: 0;
  border: 0;
  background: transparent;
  color: #1f6feb;
  cursor: pointer;
  font-size: 13px;
  overflow-wrap: anywhere;
  text-align: left;
  text-decoration: none;
}

.chat-attachment-item:hover {
  text-decoration: underline;
}

.chat-attachment-item_image:hover {
  text-decoration: none;
}

.chat-attachment-item__image {
  display: block;
  max-width: 240px;
  max-height: 180px;
  border-radius: 8px;
  object-fit: cover;
}

.chat-attachment-item__file {
  display: inline-flex;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
